import { c as _c } from "react/compiler-runtime";
import { Calendar } from "lucide-react";
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from "../ui/empty";
import { Button } from "../ui/button";
import Link from "next/link";
const EmptyEvent = () => {
  const $ = _c(4);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <EmptyMedia variant="icon"><Calendar /></EmptyMedia>;
    t1 = <EmptyTitle>No upcoming schedules available</EmptyTitle>;
    t2 = <EmptyDescription>{"We don't have any training sessions scheduled for your location at the moment.\n  Submit an enquiry and our team will help you with upcoming batches or alternative options."}</EmptyDescription>;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Empty className="border border-dashed"><EmptyHeader>{t0}{t1}{t2}<EmptyContent><Button variant="outline" size="sm" nativeButton={false} render={<Link href="#request-for-group-training" />}>Enquire Now</Button></EmptyContent></EmptyHeader></Empty>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default EmptyEvent;